/**
 * Preference entity descriptors (platform `@rammetec/data-access/preferences`).
 *
 * Registered under {@link PREFERENCE_ENTITY} names so `PreferencesService.hydrate`
 * can resolve repositories via the entity registry.
 */
import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { createPreferenceDescriptors, PREFERENCE_ENTITY, } from '@rammetec/data-access/preferences';
import { SYSTEM_ALLOWED_DATA_SOURCES } from './dataSourcePolicy.js';
export const preferenceDescriptors = createPreferenceDescriptors({
    dataSource: DataSourceStrategy.Firestore,
    // Spec notes PostgresRest readiness; SYSTEM_ALLOWED_DATA_SOURCES is Firestore-only
    // today — extend dataSourcePolicy when the pg migration lands.
    allowedDataSources: SYSTEM_ALLOWED_DATA_SOURCES,
    cache: CacheStrategy.InMemory,
});
export { PREFERENCE_ENTITY };
//# sourceMappingURL=preferences.descriptor.js.map